import { render, staticRenderFns } from "./specific-magento2.vue?vue&type=template&id=749d7965&"
import script from "./specific-magento2.vue?vue&type=script&lang=js&"
export * from "./specific-magento2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports